/**
 * Backdrop Component — Soorgaa Design System
 * 
 * Accessible, token-compliant full-screen overlay backdrop with subtle blur.
 */
import React from "react";

export interface BackdropProps {
  isOpen?: boolean;
  onClick?: () => void;
  className?: string;
  zIndex?: string;
  children?: React.ReactNode;
}

export function Backdrop({
  isOpen = true,
  onClick,
  className = "",
  zIndex = "z-40",
  children,
}: BackdropProps) {
  if (!isOpen) return null;
  return (
    <div
      className={`fixed inset-0 bg-black/60 backdrop-blur-xs transition-opacity ${zIndex} ${className}`.trim()}
      onClick={onClick}
      aria-hidden={!children}
    >
      {children}
    </div>
  );
}
